import { FilterStoreProps, FilterTypes } from '../enums'
import { ParamTypes } from '@/hooks/url/constants'

export const FiltersForUrlTypeMap: {
  [key in FilterStoreProps]?: ParamTypes
} = {
  [FilterStoreProps.SEARCH]: ParamTypes.STRING,
  [FilterStoreProps.STATUS]: ParamTypes.ARRAY,
  [FilterStoreProps.RATINGS]: ParamTypes.ARRAY,
  [FilterStoreProps.PAYMENT_METHODS]: ParamTypes.ARRAY,
  [FilterStoreProps.DELIVERY_TYPES]: ParamTypes.ARRAY,
  [FilterStoreProps.PERIOD]: ParamTypes.ARRAY,
  [FilterStoreProps.PAGE]: ParamTypes.NUMBER,
  [FilterStoreProps.PAGE_SIZE]: ParamTypes.NUMBER,
}

export const FilterStoreTypeByProp: { [prop: string]: FilterTypes } =
  Object.entries(FilterStoreProps).reduce(
    (result, [key, value]) => ({ ...result, [value]: key as FilterTypes }),
    {} as { [prop: string]: FilterTypes }
  )
